// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
function CartAnimation(Props) {
  var loopOpt = Props.loop;
  var productDirectionOpt = Props.productDirection;
  var tooltipDirectionOpt = Props.tooltipDirection;
  var addedLabelOpt = Props.addedLabel;
  var classNameOpt = Props.className;
  var enabledOpt = Props.enabled;
  var loop = loopOpt !== undefined ? loopOpt : false;
  var productDirection = productDirectionOpt !== undefined ? productDirectionOpt : /* Left */2;
  var tooltipDirection = tooltipDirectionOpt !== undefined ? tooltipDirectionOpt : /* Left */2;
  var addedLabel = addedLabelOpt !== undefined ? addedLabelOpt : "Added!";
  var className = classNameOpt !== undefined ? classNameOpt : CSS$Showside.prefix("relative w-5 h-5 bg-red-600");
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var match = EntrypointContext$Showside.use(undefined);
  var setLastProductAddedToCart = match.setLastProductAddedToCart;
  var product = match.lastProductAddedToCart;
  React.useEffect(function () {
    return function (param) {
      Curry._1(setLastProductAddedToCart, function (param) {});
    };
  }, []);
  var renderTooltip = function (param) {
    var match = addedLabel.trim();
    if (match === "") {
      return null;
    }
    var tmp;
    switch (tooltipDirection) {
      case /* Top */0:
        tmp = "animate-cart-tooltip-top left-1/2 bottom-full mb-8";
        break;
      case /* Bottom */1:
        tmp = "animate-cart-tooltip-bottom left-1/2 top-full mt-8";
        break;
      case /* Left */2:
        tmp = "animate-cart-tooltip-left top-1/2 right-full mr-8";
        break;
      case /* Right */3:
        tmp = "animate-cart-tooltip-right top-1/2 left-full ml-8";
        break;
      case /* BottomRight */4:
        tmp = "animate-cart-tooltip-bottom right-0 top-full mt-8";
        break;
      case /* BottomLeft */5:
        tmp = "animate-cart-tooltip-bottom left-0 top-full mt-8";
        break;
    }
    var tmp$1;
    var exit = 0;
    switch (tooltipDirection) {
      case /* Top */0:
      case /* Bottom */1:
        exit = 2;
        break;
      case /* Left */2:
      case /* Right */3:
        exit = 1;
        break;
      case /* BottomRight */4:
        tmp$1 = React.createElement("div", {
          className: CSS$Showside.prefix("absolute w-4 h-4 bg-primary"),
          style: {
            bottom: "auto",
            right: "5%",
            top: "-11px",
            clipPath: "polygon(50% 50%, 0% 100%, 100% 100%)"
          }
        });
        break;
      case /* BottomLeft */5:
        tmp$1 = React.createElement("div", {
          className: CSS$Showside.prefix("absolute w-4 h-4 bg-primary"),
          style: {
            bottom: "auto",
            left: "5%",
            top: "-11px",
            clipPath: "polygon(50% 50%, 0% 100%, 100% 100%)"
          }
        });
        break;
    }
    switch (exit) {
      case 1:
        tmp$1 = React.createElement("div", {
          className: CSS$Showside.prefix("absolute w-4 h-4 bg-primary"),
          style: {
            left: tooltipDirection === /* Right */3 ? "-11px" : "auto",
            right: tooltipDirection === /* Right */3 ? "auto" : "-11px",
            top: "50%",
            clipPath: tooltipDirection === /* Right */3 ? "polygon(100% 0, 50% 50%, 100% 100%)" : "polygon(0 0, 0 100%, 50% 50%)",
            transform: "translateY(-50%)"
          }
        });
        break;
      case 2:
        tmp$1 = React.createElement("div", {
          className: CSS$Showside.prefix("absolute w-4 h-4 bg-primary"),
          style: {
            bottom: tooltipDirection === /* Bottom */1 ? "auto" : "-11px",
            left: "50%",
            top: tooltipDirection === /* Bottom */1 ? "-11px" : "auto",
            clipPath: tooltipDirection === /* Bottom */1 ? "polygon(50% 50%, 0% 100%, 100% 100%)" : "polygon(50% 50%, 0 0, 100% 0)",
            transform: "translateX(-50%)"
          }
        });
        break;
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute bg-primary text-main rounded-custom opacity-0 whitespace-nowrap shadow-lg px-3 py-2 text-base", tmp, loop ? "force-loop" : ""]))
    }, tmp$1, addedLabel);
  };
  var renderProductImage = function (product) {
    var firstImage = Product$Showside.Media.getImageUrlWithPosterFallback(product.media);
    var tmp;
    switch (productDirection) {
      case /* Top */0:
        tmp = "animate-cart-product-top top-1/2 left-1/2";
        break;
      case /* Left */2:
        tmp = "animate-cart-product-left left-1/2 top-1/2";
        break;
      case /* Right */3:
        tmp = "animate-cart-product-right left-1/2 top-1/2";
        break;
      case /* Bottom */1:
      case /* BottomRight */4:
      case /* BottomLeft */5:
        tmp = "animate-cart-product-bottom top-1/2 left-1/2";
        break;
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute rounded-custom bg-main shadow-lg relative p-0.5 w-12 h-12 bg-opacity-80", tmp, loop ? "force-loop" : ""]))
    }, firstImage !== undefined ? React.createElement(SmartImg$Showside.Sized.make, {
      src: firstImage,
      containerWidth: 32,
      containerHeight: 32,
      fit: /* Cover */1,
      priority: 1,
      alt: Belt_Option.getWithDefault(product.name, "Product image")
    }) : null);
  };
  if (product !== undefined && enabled) {
    return React.createElement("div", {
      className: Cn.make([className, CSS$Showside.prefix("top-0 left-0 flex items-center justify-center")])
    }, React.createElement("div", {
      className: CSS$Showside.prefix("relative inline-block w-5 h-5")
    }, renderTooltip(undefined), renderProductImage(product)));
  } else {
    return null;
  }
}
CartAnimation.displayName = "CartAnimation";
var make = CartAnimation;
export { make };
/* react Not a pure module */